import { client } from "../../../Infrastructure/agent";

export const FiscalizationService = {
  initailizeFiscalzation: (year, assetId, uploadedBy) =>
    client.post("/Fiscalization/InitailizeFiscalization", {
      year,
      assetId,
      uploadedBy,
    }),
  getAssetFiscalizationByYear: (year, assetId) =>
    client.post("/Fiscalization/GetFiscalizationsByYear", {
      year,
      assetId,
    }),

  saveFiscalizations: (fiscalizations, year, uploadedBy, assetId) =>
    client.post("/Fiscalization/SaveFiscalization", {
      fiscalizations,
      year,
      uploadedBy,
      assetId,
    }),

  saveMonthTarget: (fiscal, uploadedBy) =>
    client.post("/Fiscalization/SaveMonthFiscalization", {
      fiscal,
      uploadedBy,
    }),
};

